import { useState } from "react";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";

const testimonials = [
  {
    quote:
      "I called the bank for 3 months and got nowhere. DirectFundCap had us approved in 4 hours and funded $180K the next morning. We opened our second location six weeks later.",
    name: "Marco Reyes",
    title: "Owner, Reyes Hospitality Group",
    industry: "Restaurants · NY",
  },
  {
    quote:
      "The transparency was a relief. Flat factor, no junk fees, my own dedicated specialist. We've come back three times — bigger amounts, better terms each round.",
    name: "Tasha Williams",
    title: "Founder, Brightline Trucking",
    industry: "Trucking · TX",
  },
  {
    quote:
      "Fastest funding experience I've had in 22 years of running businesses. Application took 9 minutes, money hit our account the same day.",
    name: "David Chen",
    title: "President, Apex Construction Co.",
    industry: "Construction · CA",
  },
  {
    quote:
      "We needed working capital for an inventory buy and our timeline was tight. They funded us in 19 hours from first call to wire. That deal alone added $400K to our top line.",
    name: "Priya Shah",
    title: "CEO, Maven Goods",
    industry: "E-commerce · IL",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = testimonials[i];

  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-gold mb-5">Real Results</div>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-white tracking-tighter">
              Operators who chose us — and came back.
            </h2>
            <div className="flex items-center gap-1 mt-8">
              {[...Array(5)].map((_, idx) => (
                <Star key={idx} className="w-5 h-5 fill-gold text-gold" />
              ))}
              <span className="ml-3 text-white/70 text-sm">4.9 / 5 · 1,200+ funded clients</span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative bg-[#0A1326] border border-white/10 p-10 md:p-14">
              <Quote className="w-12 h-12 text-gold/30 absolute top-6 right-6" />
              <p className="font-heading text-2xl md:text-3xl text-white leading-snug font-light tracking-tight">
                "{t.quote}"
              </p>
              <div className="mt-10 pt-6 border-t border-white/10 flex items-center justify-between gap-6 flex-wrap">
                <div>
                  <div className="font-semibold text-white" data-testid="testimonial-name">{t.name}</div>
                  <div className="text-sm text-white/50">{t.title}</div>
                  <div className="text-xs text-gold mt-1 tracking-widest uppercase">{t.industry}</div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => setI((i - 1 + testimonials.length) % testimonials.length)}
                    data-testid="testimonial-prev"
                    aria-label="Previous"
                    className="w-11 h-11 border border-white/20 hover:border-gold hover:text-gold flex items-center justify-center text-white/70 transition-colors"
                  >
                    <ChevronLeft className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => setI((i + 1) % testimonials.length)}
                    data-testid="testimonial-next"
                    aria-label="Next"
                    className="w-11 h-11 border border-white/20 hover:border-gold hover:text-gold flex items-center justify-center text-white/70 transition-colors"
                  >
                    <ChevronRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div className="mt-6 flex gap-1.5">
                {testimonials.map((_, idx) => (
                  <button
                    key={idx}
                    aria-label={`Show testimonial ${idx + 1}`}
                    data-testid={`testimonial-dot-${idx}`}
                    onClick={() => setI(idx)}
                    className={`h-1 transition-all ${idx === i ? "w-10 bg-gold" : "w-4 bg-white/15 hover:bg-white/30"}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
